(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pe-despacho"] && !Shopify.designMode) return;
  try {
    (function () {
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

    // El visitante puede estar en cualquier huso horario; el despacho ocurre
    // en Chile. Esto devuelve una fecha cuyos campos locales son la hora
    // chilena, que es con lo que se compara todo más abajo.
    function ahoraEnChile() {
      try {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' }));
      } catch (e) {
        return null;
      }
    }

    function aTexto(d) {
      var m = d.getMonth() + 1;
      var dia = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dia < 10 ? '0' : '') + dia;
    }

    function dosCifras(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function calcular(caja) {
      var ahora = ahoraEnChile();
      if (!ahora) return null;

      var feriados = (caja.getAttribute('data-feriados') || '').split(',');
      var esFeriado = {};
      for (var i = 0; i < feriados.length; i++) {
        var f = feriados[i].trim();
        if (f) esFeriado[f] = true;
      }

      var corte = (caja.getAttribute('data-corte') || '12:00').split(':');
      var hh = parseInt(corte[0], 10);
      var mm = parseInt(corte[1], 10) || 0;
      if (isNaN(hh)) return null;

      var limite = new Date(ahora.getTime());
      limite.setHours(hh, mm, 0, 0);

      // Hoy sirve solo si no es feriado y todavía no pasa la hora de corte.
      if (!esFeriado[aTexto(ahora)] && ahora < limite) {
        var falta = Math.floor((limite - ahora) / 1000);
        return { hoy: true, segundos: falta };
      }

      // Si no, se busca el primer día que no sea feriado. El tope de 30 es
      // por seguridad: sin él, una lista mal escrita dejaría el ciclo vivo.
      var salto = new Date(ahora.getTime());
      for (var v = 1; v <= 30; v++) {
        salto.setDate(salto.getDate() + 1);
        if (!esFeriado[aTexto(salto)]) {
          return {
            hoy: false,
            dias: v,
            fecha: salto,
            feriadoHoy: !!esFeriado[aTexto(ahora)]
          };
        }
      }
      return null;
    }

    function frase(r) {
      if (r.hoy) {
        var s = r.segundos;
        var h = Math.floor(s / 3600);
        var m = Math.floor((s % 3600) / 60);
        var seg = s % 60;
        var reloj = h > 0 ? h + ' h ' + dosCifras(m) + ' min' : dosCifras(m) + ':' + dosCifras(seg) + ' min';
        return 'Pídelo en las próximas <strong>' + reloj + '</strong> y se despacha hoy.';
      }
      var inicio = r.feriadoHoy ? 'Hoy es feriado. ' : '';
      if (r.dias === 1) return inicio + 'Tu pedido se despacha <strong>mañana</strong>.';
      return (
        inicio +
        'Tu pedido se despacha el <strong>' +
        DIAS[r.fecha.getDay()] +
        ' ' +
        r.fecha.getDate() +
        '</strong>.'
      );
    }

    function pintar(caja) {
      var r = calcular(caja);
      // Sin resultado se deja la frase de respaldo que vino del servidor.
      if (!r) return false;
      var txt = caja.querySelector('[data-pe-despacho-txt]');
      if (txt) txt.innerHTML = frase(r);
      return r.hoy;
    }

    var reloj = null;

    function iniciar() {
      var cajas = document.querySelectorAll('[data-pe-despacho]');
      if (!cajas.length) return;
      var alguna = false;
      Array.prototype.forEach.call(cajas, function (caja) {
        if (pintar(caja)) alguna = true;
      });
      if (reloj) clearInterval(reloj);
      // Solo hace falta un reloj mientras haya una cuenta corriendo.
      if (alguna) {
        reloj = setInterval(function () {
          var sigue = false;
          Array.prototype.forEach.call(document.querySelectorAll('[data-pe-despacho]'), function (caja) {
            if (pintar(caja)) sigue = true;
          });
          if (!sigue) {
            clearInterval(reloj);
            reloj = null;
          }
        }, 1000);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();
  } catch(e) { console.error(e); }
})();

})();
